import React, { useContext, useState } from 'react';
import UserProvider from '../../context/UserContext';
import toast from 'react-hot-toast';

export const CardExitConfirmation = () => {
    
    const Context = useContext(UserProvider.context);
    
    const [enabled, setEnabled] = useState(true);

    const handleShowExitWaitlist = () => {
        Context.setExitWaitlist(!Context.showExitWaitlist)
    }

    const handleExitWaitlist = () => {
        if(enabled){
            const url = `${process.env.REACT_APP_API_URL}/waitlist/`
            setEnabled(false)
            
            const form = new FormData()
            form.append('disabled', true)

            fetch(url, {
                credentials: "include",
                method: 'PATCH',
                body: JSON.stringify({ "disabled": true }),
                headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
            })
            .then(function (response) {
                if(response.status === 200){
                    toast.success('Successfuly removed');
                    setTimeout(() => { 
                        Context.setWaitlisted(false) 
                        Context.setExitWaitlist(false)
                    }, 1500); 
                }
                else if(response.status === 400){
                    response.json().then(function(data){
                        if(data.code === "ALREADY_USER") {
                            //alertError("Already user")
                            toast.error('Already owning Infinit');
                            setTimeout(() => { 
                                Context.setIsUser(true)
                                Context.setExitWaitlist(false)
                            }, 1500); 
                        }
                        else if(data.code === "DOES_NOT_QUALIFY") {
                            //alertError("Your account doesn't quality")
                            toast.error(`Your account doesn't qualify`);
                            setTimeout(() => { 
                                Context.setBanned(true)
                                Context.setExitWaitlist(false)
                            }, 1500);
                        }
                        else{
                            toast.error('Unable to exit the waitlist');
                        }
                    })
                }
                else{
                    toast.error('Unable to exit the waitlist');
                }
                setEnabled(true)
            })
            .catch(err => {
                toast.error('Unable to exit the waitlist');
                setEnabled(true)
                console.log(err)
            });
        }
    }

    return(
        <div className="card-component card-exit">
            <div className="card-content">
                <div className="exit-confirmation-handle">
                    <h2 className="exit-confirmation-title">Are you sure?</h2>
                    <h4 className="exit-confirmation-text">You will lose your spot in the waitlist</h4>
                    <div className="exit-confirmation-button-holder">
                        <div className="exit-confirmation-close-button-holder">
                            <button className="exit-confirmation-yes-button" disabled={!enabled} onClick={handleExitWaitlist}>Yes</button>
                        </div>
                        <div className="exit-confirmation-close-button-holder">
                            <button className="exit-confirmation-no-button" onClick={handleShowExitWaitlist}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

};